import { render } from "./Agenda.vue?vue&type=template&id=ebb3ce54&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Agenda.vue?vue&type=style&index=0&id=ebb3ce54&module=true&lang=css"
cssModules["$style"] = style0
import "./Agenda.vue?vue&type=style&index=1&id=ebb3ce54&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-ebb3ce54"]])

export default __exports__